import React, { useState, useEffect, useRef } from 'react';
import jsPDF from "jspdf";
import { fontStyles, labelColors, valueColors, lineColors } from '../../components/fontStylesColors'; // adjust path as needed



import FormSection from "../../components/FormSection";
import TodoList from "../../components/TodoList";
import { generateComplexCaptcha } from "../../components/Captcha";
import Captcha from "../../components/Captcha";
import HiddenQRCode from "../../components/HiddenQRCode";
import ImageSelector from '../../components/ImageSelector';
import ImagePhoto from "../../components/ImagePhoto"; 
import PaymentButton from "../../components/PaymentButton";
import Semester from "../../components/Semester";

import "../../components/Leto.css";

function Topo() {
  const [formData, setFormData] = useState({
    name1: "",
    study1: "",
    AdmNo1: "",
    School1: "",
	comm: "",
	
	
	selection1: "Name",
    selection2: "Study",
    selection3: "AdmNo",
    selection4: "School",
	selection5: "Dream",
	
	
  });
  
  
  //for Semester
  
   const [formData1, setFormData1] = useState({
    selection6: "Semester",
    selection7: "",
  });
  
  
  
  //for ImageSelector
  const [images, setImages] = useState([]);
  const [selectedImages, setSelectedImages] = useState([]);
  const [highlightedImages, setHighlightedImages] = useState([]);
  const [filter, setFilter] = useState('all');
  const [filteredImages, setFilteredImages] = useState([]);
  const [showValidationMessage, setShowValidationMessage] = useState(false);
  const [resetDefaults, setResetDefaults] = useState(0); // Use a counter for resets
  const [touched, setTouched] = useState({});
  const formRef = useRef(null); //form reference to reset form data
  
  //for payment logic
  
   const [isPaid, setIsPaid] = useState(false); // Track payment status
  const [amount, setAmount] = useState(4000); // Default price ₹500 (in paise)
  const [promoCode, setPromoCode] = useState("");
  const [discount, setDiscount] = useState(0);
  const [errorPayment, setErrorPayment] = useState("");
  
  
  // Promo codes list (You can fetch from backend if needed)
  const promoCodes = {
    //"LETO": 10, // ₹5 off
   // "TOPO": 10, // ₹5 off
	"PITICS": 5, // ₹5 off
  };

  // Apply Promo Code
  const applyPromoCode = () => {
    if (promoCode in promoCodes) {
      const discountValue = promoCodes[promoCode] * 100; // Convert ₹ to paise
      setDiscount(discountValue);
      setAmount(4000 - discountValue); // Update price after discount
      setErrorPayment("");
    } else {
      setErrorPayment("Invalid Promo Code");
      setDiscount(0);
      setAmount(4000); // Reset amount if promo code is invalid
    }
  };
  
   // Remove Discount
  const removeDiscount = () => {
    setDiscount(0);
    setAmount(4000); // Reset to original price
    setPromoCode(""); // Clear promo code input
    setErrorPayment("");
  };
  
  
  
  
  
  
  //ends here

  // Load images from multiple folders dynamically image selector
  useEffect(() => {
  const importAllImages = (context) => context.keys().map(context);

  const imagesFromFolders = [
    ...importAllImages(require.context('./images', false, /\.(png|jpe?g)$/)).map((img) => ({
      src: img,
      category: 'general',
    })),
    ...importAllImages(require.context('./Animation', false, /\.(png|jpe?g)$/)).map((img) => ({
      src: img,
      category: 'animation',
    })),
    ...importAllImages(require.context('./Technology', false, /\.(png|jpe?g)$/)).map((img) => ({
      src: img,
      category: 'technology',
    })),
    ...importAllImages(require.context('./Sports', false, /\.(png|jpe?g)$/)).map((img) => ({
      src: img,
      category: 'sports',
    })),
    ...importAllImages(require.context('./Science', false, /\.(png|jpe?g)$/)).map((img) => ({
      src: img,
      category: 'science',
    })),
  ];

  setImages(imagesFromFolders);
}, []);

{/* const filterImages = (selectedFilter) => {
    if (selectedFilter === 'all') {
      return images;
    }
    return images.filter((img) => img.category === selectedFilter);
  };

  useEffect(() => {
    setFilteredImages(filterImages(filter));
  }, [filter, images]);


*/}


useEffect(() => {
  const filterImages = (selectedFilter) => {
    if (selectedFilter === 'all') {
      return images;
    }
    return images.filter((img) => img.category === selectedFilter);
  };

  setFilteredImages(filterImages(filter));
}, [filter, images]);






//ImageSelector part1 ends


 //for form fields validation to not allow special characters
  const namePattern = /^[\p{L}\p{N}'.:-]+(?: [\p{L}\p{N}'.@:-]+)* ?$/u;



  // Capitalize first letter of each word, maintain single spaces
  const formatName = (value) => {
    return value
      .toLowerCase()
      .replace(/ +/g, " ") // Replace multiple spaces with single space
      .replace(/\b\w/g, (char) => char.toUpperCase());
  };

  
  
  
  //todos logic
  const [errors, setErrors] = useState({});
  const defaultTodos = [
    { id: 1, text: "English Text Book", isEditing: false },
    { id: 2, text: "English Grammer Book", isEditing: false },
    { id: 3, text: "English Note Book", isEditing: false },
    { id: 4, text: "English Work Book", isEditing: false },
    { id: 5, text: "Maths Text Book", isEditing: false },
	{ id: 6, text: "Maths Note Book", isEditing: false },
	{ id: 7, text: "Maths Work Book", isEditing: false },
	{ id: 8, text: "Science Text Book", isEditing: false },
	{ id: 9, text: "Science Work Book", isEditing: false },
	{ id: 10, text: "Science Note Book", isEditing: false },

	
  ];

  const [todos, setTodos] = useState(defaultTodos);
  const [captcha, setCaptcha] = useState(generateCaptcha());
  const [userCaptcha, setUserCaptcha] = useState("");
  const [todoError, setTodoError] = useState("");
  const [captchaError, setCaptchaError] = useState("");

  function generateCaptcha() {
    const { imageUrl, text } = generateComplexCaptcha();
    return { imageUrl, text };
  }

  function refreshCaptcha() {
    setCaptcha(generateCaptcha());
    setUserCaptcha("");
    setCaptchaError("");
  }
  
    

  const validateField = (name, value) => {
    let errorMessage = "";
	
    if (!value.trim()) {
      errorMessage = "This field is required";
    } else if (value.length < 2) {
      errorMessage = "Must be at least 2 characters";
    } else if (value.length > 25) {
      errorMessage = "Must not exceed 25 characters";
    } else if (!namePattern.test(value)) {
      errorMessage = "Spl chars ' . @ - : allows only ";
    }

    setErrors((prevErrors) => ({ ...prevErrors, [name]: errorMessage }));
    return errorMessage;
  };
  
  
  
  
  
   // Handle input change (immediate validation)
   {/* const handleChange = (e) => {
    const { name, value } = e.target;
    const formattedValue = formatName(value);
    setFormData((prevData) => ({
      ...prevData,
      [name]: formattedValue,
    }));
    setTouched((prevTouched) => ({
      ...prevTouched,
      [name]: true,
    }));
    validateField(name, formattedValue);
  };
   
   
   
   //for only upper case of admno field
   
   const handleChange = (e) => {
  const { name, value } = e.target;

  const formattedValue =
    name === "AdmNo1" ? value.toUpperCase() : formatName(value);

  setFormData((prevData) => ({
    ...prevData,
    [name]: formattedValue,
  }));

  setTouched((prevTouched) => ({
    ...prevTouched,
    [name]: true,
  }));

  validateField(name, formattedValue);
};

   */}
   
   
   //handle change and only allow capital letters in admission number
   const handleChange = (e) => {
  const { name, value } = e.target;

  const formattedValue =
    name === "AdmNo1" ? value : formatName(value);

  setFormData((prevData) => ({
    ...prevData,
    [name]: formattedValue,
  }));

  setTouched((prevTouched) => ({
    ...prevTouched,
    [name]: true,
  }));

  validateField(name, formattedValue);
};

   
  
  //handleChange1 for semester field
  const handleChange1 = (e) => {
    const { name, value } = e.target;
    setFormData1((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  


  const validateForm = () => {
    const newErrors = {};
    Object.keys(formData).forEach((key) => {
      if (!key.includes("selection")) {
        const error = validateField(key, formData[key]);
        if (error) newErrors[key] = error;
      }
    });
	
	//for todo validation while payment
	
	 if (todos.length === 0) {
        newErrors.todoError = "Please add at least one subject.";
        setTodoError("Please add at least one subject.");
    } else {
        setTodoError(""); // Clear error if validation passes
    }
	
	//ends here
	
	  // Validate if at least one image is selected
    if (selectedImages.length === 0) {
        newErrors.imageError = "Please select at least one image.";
        setShowValidationMessage(true);
    } else {
        setShowValidationMessage(false); // Clear error if validation passes
    }
	//ends here
	
	 // Validate if at least one photo is uploaded
    if (photos.every((photo) => !photo)) {
        newErrors.photoError = "Upload at least one photo.";
        setValidationMessage("Upload at least one photo.");
    } else {
        setValidationMessage(""); // Clear error if validation passes
    }
   //ends here
   
    // Validate Captcha
    if (userCaptcha !== captcha.text) {
        newErrors.captchaError = "Invalid captcha!";
        setCaptchaError("Invalid captcha!");
    } else {
        setCaptchaError(""); // Clear error if validation passes
    }
	
	
	
	
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  
  
  

  const handleTodoInputChange = (newTodos) => {
    setTodos(newTodos);
    if (newTodos.length > 0) {
      setTodoError("");
    }
  };

  const handleDeleteAllTodos = () => {
    setTodos([]);
  };
// todos ends here


//captcha loigc
  const handleCaptchaChange = (value) => {
    setUserCaptcha(value);
    if (value === captcha.text) {
      setCaptchaError("");
    }
  };
  
  //captcha ends here
  
  //superscript input

  const processInput = (inputText) => {
    const cleanedInput = inputText.replace(/[ʰ-˿ᴀ-ᵿ]/g, "");

    return cleanedInput.replace(/\b(\d+)\b/g, (match, number) => {
      const num = parseInt(number, 10);
      let suffix = "th";

      if (num % 10 === 1 && num % 100 !== 11) suffix = "st";
      else if (num % 10 === 2 && num % 100 !== 12) suffix = "nd";
      else if (num % 10 === 3 && num % 100 !== 13) suffix = "rd";

      return `${num}${suffix}`;
    });
  };

 const addSuperscriptSuffix = (text) => {
  return text.replace(/(\d+)(st|nd|rd|th)/g, (match, number, suffix) => {
    return `${number}${suffix}`;
  });
};
//superscript input ends here



// for upload photo
  const [photos, setPhotos] = useState([null, null, null]);
  const [validationMessage, setValidationMessage] = useState("");
  const fileInputsRef = useRef([]);
  const labels = ["Photo1", "Photo2", "Photo3", "Photo4"];
  
  //to disappear error message after photo uploaded
  const handlePhotoUpload = (photo, index) => {
    setPhotos((prev) => {
      const updatedPhotos = [...prev];
      updatedPhotos[index] = photo;

      // Clear validation message if at least one photo is uploaded
      if (updatedPhotos.some((uploadedPhoto) => uploadedPhoto)) {
        setValidationMessage("");
      }

      return updatedPhotos;
    });
  };
  
  
//part1 of upload photo ends here


//if payment successful auto Download of PDF


// Inside your component
useEffect(() => {
  if (isPaid) {
    const timer = setTimeout(async () => {
      await generatePDF(); // wait until PDF generation & download finishes
      //resetForm();         // now reset safely
	   window.location.reload(); // then reload the page
    }, 1000);

    return () => clearTimeout(timer);
  }
}, [isPaid]);




//ends auto downlaod of PDF


  const generatePDF = async () => {
    if (todos.length < 1 || todos.length > 48) {
      setTodoError("Add least one subject.");
      return;
    }
    
	
	
	
	
	
	
	
	
	
	
	
const doc = new jsPDF();
const rowsPerPage = 6;
const totalPages = 8;
const totalRows = rowsPerPage * totalPages;

const pageWidth = doc.internal.pageSize.getWidth();
const pageHeight = doc.internal.pageSize.getHeight();

const marginY = 10;

let gridCount = 0;

	 const { font, size, color } = fontStyles[0];
  const labelColor = labelColors[0];
  const valueColor = valueColors[0];
  const lineColor = lineColors[0];
  
  
  
// Subtract vertical space taken by gaps (5 gaps × 2px)
const totalGapHeight = (rowsPerPage - 1) * 2;
const usableHeight = pageHeight - 2 * marginY - totalGapHeight;
const rowHeight = usableHeight / rowsPerPage;

// 🟦 You can change the grid width and height here
const gridWidth = pageWidth - 95; // Decrease width here (e.g., 60px total less than full width)
const gridHeight = rowHeight;

todos.forEach((todo, index) => {
  const gridsPerPage = rowsPerPage;
  const currentPage = Math.floor(gridCount / gridsPerPage);
  const row = gridCount % gridsPerPage;

  if (row === 0 && gridCount > 0) {
    doc.addPage();
  }

  const startY = marginY + row * (gridHeight + 2);
  const startX = (pageWidth - gridWidth) / 2; // 🟨 Center grid horizontally on the page

  const fontStyle = fontStyles[gridCount % fontStyles.length];

  //doc.setDrawColor(0); // Black border
  //doc.setLineWidth(0.5);
  //doc.rect(startX, startY, gridWidth, gridHeight); // 🟦 Grid border

  doc.setFont(fontStyle.font, "normal");
  doc.setFontSize(fontStyle.size);
  doc.setTextColor(...fontStyle.color);
  doc.text(todo.text, startX + 5, startY + 10);

  const imageCount = selectedImages.length;
  const imageIndex = index % imageCount;
  const imageUrl = selectedImages[imageIndex];

  doc.addImage(imageUrl, 'JPEG', startX, startY, gridWidth, gridHeight); // image padding inside grid

  
  
	  
	  
	  
	  
	  
	  
	  //upload Photo
	  
	  
	  // Only use uploaded photos
	const availablePhotos = photos.filter((photo) => photo); 
    const photoCount = availablePhotos.length;
  
  
   
   
   

	
	  
      // Add uploaded photos cyclically if any are available
	   if (photoCount > 0) {
    const photoIndex = index % photoCount;
    const photo = availablePhotos[photoIndex];
    
  // Image dimensions (reduced by 1px each)
const imageWidth = 17; // was 18
const imageHeight = 21; // was 22
const borderThickness = 0.2;
const borderRadius = 1;

// Base image position + custom offsets
const baseImageX = startX + 8;
const baseImageY = startY + 18;
const imageX = baseImageX + 79 + 4;   // Added extra 4px
const imageY = baseImageY - 10 - 1;   // Subtracted extra 1px

// Rectangle dimensions and position based on new image position
const rectX = imageX - borderThickness;
const rectY = imageY - borderThickness;
const rectWidth = imageWidth + 2 * borderThickness;
const rectHeight = imageHeight + 2 * borderThickness;

// Draw the rounded rectangle
doc.setLineWidth(borderThickness);
doc.setDrawColor(128, 0, 128); // Purple
doc.roundedRect(rectX, rectY, rectWidth, rectHeight, borderRadius, borderRadius);

// Add the image
doc.addImage(photo, "JPEG", imageX, imageY, imageWidth, imageHeight);



}

	  
	  //background of Photo
	  
	  const imageUrls = ['plain1.jpg', 'plain2.jpg', 'plain3.jpg', 'plain4.jpg'];
const imageIndex1 = index % imageUrls.length;
const imageUrl1 = imageUrls[imageIndex1];

doc.addImage(imageUrl1, 'JPEG', startX + 8, startY + 18, 17, 22);

	  
	  
	  
	  //background of Photo ends here
	



	  
	  
	
	

   
	  
	  //ends upload photo
	 
	 
	 
	 
	 
	  
	  

      doc.setFont(fontStyle.font, "normal");
      doc.setFontSize(fontStyle.size);
      doc.setTextColor(...fontStyle.color);
	  
	  
	  
	  
	  //superscript
	  
	  
    const processInput = (inputText) => {
    const cleanedInput = inputText.replace(/[ʰ-˿ᴀ-ᵿ]/g, "");

    return cleanedInput.replace(/\b(\d+)\b/g, (match, number) => {
        const num = parseInt(number, 10);
        let suffix = "th";

        if (num % 10 === 1 && num % 100 !== 11) suffix = "st";
        else if (num % 10 === 2 && num % 100 !== 12) suffix = "nd";
        else if (num % 10 === 3 && num % 100 !== 13) suffix = "rd";

        return `${num}${suffix}`;
    });
};

const drawTextWithSuperscript = (doc, text, startX, startY) => {
    const words = text.split(" "); // Split text into words for proper line rendering
    let currentX = startX;

    words.forEach((word) => {
        const match = word.match(/(\d+)(st|nd|rd|th)?/); // Separate number and suffix
        if (match) {
            const number = match[1];
            const suffix = match[2];

            // Draw the number
            doc.text(number, currentX, startY);
            currentX += doc.getTextWidth(number);

            if (suffix) {
                // Draw the suffix slightly higher and smaller
                const suffixOffset = 1.5; // Adjust for desired superscript height
                const originalFontSize = doc.getFontSize();
                doc.setFontSize(originalFontSize * 0.85); // Reduce font size for superscript
                doc.text(suffix, currentX, startY - suffixOffset);
                doc.setFontSize(originalFontSize); // Reset font size
                currentX += doc.getTextWidth(suffix);
            }
        } else {
            // Draw normal word
            doc.text(word, currentX, startY);
            currentX += doc.getTextWidth(word);
        }

        // Add space between words
        currentX += doc.getTextWidth(" ");
    });
    
    // To adjust the superscript size, modify the multiplier in `originalFontSize * 0.8`
    // For example, change to `originalFontSize * 0.7` for smaller superscripts.
};

// Process the input and prepare the text
const processedInput = processInput(formData.study1);
const lines = doc.splitTextToSize(processedInput, 180);

// Render additional text
const selection1Text = `${formData.selection1}: ${formData.name1}`;
const selection2AndInputText = `${formData.selection2}: ${processedInput}`;

//doc.text(selection1Text, startX+27, startY + 20);

// Render the `selection2` and `processedInput` text beside each other
const selection2Width = doc.getTextWidth(`${formData.selection2}: `);



      
       const label1 = `${formData.selection1}:`;
	   const label2 = `${formData.selection2}:`;
	   const label3 = `${formData.selection3}:`;
	   const label4 = `${formData.selection4}:`;
	   const label5 = `${formData.selection5}:`;
	   const label6 = `Subject:`;
	   
	   
	   
	   const maxLabelWidth = Math.max(
	   doc.getTextWidth(label1), 
	   doc.getTextWidth(label2), 
	   doc.getTextWidth(label3), 
	   doc.getTextWidth(label4), 
	   doc.getTextWidth(label5), 
	   doc.getTextWidth(label6)
	   );
	   
	   
	   // Define a common alignment starting point for the text after the colon
       
	   const textStartX = startX + 27 + maxLabelWidth + 1; // Add 5 for spacing after the colon
	   
	   
	   
	

      // Function to draw text with specific color
      doc.setTextColor(labelColors[0]); 	  
       doc.text(label1, startX + 27, startY + 15);
	   doc.setTextColor(valueColors[0]);
       doc.text(`${formData.name1}`, textStartX, startY + 15);
	   doc.setDrawColor(lineColors[0]);
	  doc.setLineWidth(0.2); // Set line thickness
      doc.line(startX + 27, startY + 16, textStartX + 49, startY + 16);
	  
        
       doc.setTextColor(labelColors[1]); 	  
	   doc.text(label2, startX + 27, startY + 21);
	   doc.setTextColor(valueColors[1]);
       drawTextWithSuperscript(doc, processedInput, textStartX, startY + 21);
	   doc.setDrawColor(lineColors[1]);
	  doc.setLineWidth(0.2); // Set line thickness
      doc.line(startX + 27, startY + 22, textStartX + 49, startY + 22);
	  
	   
	   doc.setTextColor(labelColors[2]); 
       doc.text(label3, startX + 27, startY + 27);
	   doc.setTextColor(valueColors[2]);
	   const admNo1 = `${formData.AdmNo1}`; // First field data
       doc.text(admNo1, textStartX, startY + 27);

       // Calculate the width of the first field's text
       const admNo1Width = doc.getTextWidth(admNo1);

       // Place the second field right after the first field
       const semester = `${formData1.selection7}`; // Second field data
	   doc.setTextColor(labelColors[4]); 
       doc.text(semester, textStartX + admNo1Width + 2, startY + 27); // Add 5 for padding	   
	   doc.setDrawColor(lineColors[2]);
	  doc.setLineWidth(0.2); // Set line thickness
      doc.line(startX + 27, startY + 28, textStartX + 49, startY + 28);
	  
	   
       //doc.text(`${formData.AdmNo1}`, textStartX, startY + 39);
       doc.setTextColor(labelColors[3]); 
       doc.text(label4, startX + 27, startY + 33);
	   doc.setTextColor(valueColors[3]);
       doc.text(`${formData.School1}`, textStartX, startY + 33);
	   doc.setDrawColor(lineColors[3]);
	   doc.setLineWidth(0.2); // Set line thickness
       doc.line(startX + 27, startY + 34, textStartX + 49, startY + 34);
	  
       
	   //doc.text(label5, startX + 27, startY + 50);
       //doc.text(`${formData.comm}`, textStartX, startY + 50);
       doc.setTextColor(labelColors[4]); 
       doc.text(label6, startX + 27, startY + 39);
       doc.setTextColor(valueColors[4]);
       // Add the todo text at the specified coordinates
       doc.text(`${todo.text}`, textStartX, startY + 39);
	   doc.setDrawColor(lineColors[4]);
	   doc.setLineWidth(0.2); // Set line thickness
       doc.line(startX + 27, startY + 40, textStartX + 49, startY + 40);
	  

// Find the QR code canvas element by its ID
const qrCodeCanvas = document.getElementById(`qr-${index}`);

// If the QR code canvas exists, convert it to a PNG image and add it to the document
if (qrCodeCanvas) {
  const qrImage = qrCodeCanvas.toDataURL("image/png");
  doc.addImage(qrImage, "PNG", startX+94, startY + 30, 11, 11);
}

      gridCount += 1;
    });
	
	

    doc.save(`${formData.name1}`);
  };




  const handleSubmit = (e) => {
    e.preventDefault();

	 if (!validateForm()) return;
	
	
	 let isValid = true;
    let newErrors = {};

    // Validate all fields
    Object.keys(formData).forEach((key) => {
      const value = formatName(formData[key]);
      let errorMsg = "";

      if (!value.trim()) {
        errorMsg = "This field is required";
      } else if (value.length < 2) {
        errorMsg = "Must be at least 2 characters";
      } else if (value.length > 25) {
        errorMsg = "Must not exceed 25 characters";
      } else if (!namePattern.test(value)) {
        errorMsg = "Only letters, hyphens, apostrophes, ";
      }

      newErrors[key] = errorMsg;
      if (errorMsg) isValid = false;
    });

    setErrors(newErrors);
    setTouched({ name1: true, name2: true, name3: true, name4: true });
	

    if (todos.length === 0) {
      setTodoError("Please add at least one subject.");
      return;
    }
	
	
	
	//for ImageSelector
	 if (selectedImages.length === 0) {
      setShowValidationMessage(true);
      return;
    }
    setShowValidationMessage(false);
	//ends ImageSelector
	
	//for upload photo validation
	  if (photos.every((photo) => !photo)) {
      setValidationMessage("Upload at least one photo");
      return;
    }
	
	 

    setValidationMessage("");
	//upload photo ends here
	
	
	
	//FOR USER CAPTCHA validation

    if (userCaptcha !== captcha.text) {
      setCaptchaError("Invalid captcha!");
      return;
    }
	
	
	
	
	
  };
  
  const resetForm = () => {
  if (formRef.current) {
    formRef.current.reset();
  }
  if (isPaid) {  

  
//resetting all form fields
    setFormData({
      name1: "",
      study1: "",
      AdmNo1: "",
      School1: "",
	  comm: "", 
    selection1: "Name",
    selection2: "Study",
    selection3: "AdmNo",
    selection4: "School",
	selection5: "Dream",

    });


 // Reset the semester
    setFormData1({
      selection6: "Semester",
      selection7: "",
    });


    setTodos(defaultTodos);
    setUserCaptcha("");
    setCaptcha(generateCaptcha());
    setTodoError("");
	

	// Reset ImageSelector after form submission
    setSelectedImages([]);
    setHighlightedImages([]);
    setFilter('all');
    setResetDefaults((prev) => prev + 1); // Increment counter to ensure resets work every time
	
	
	//ends ImageSelector here
    setCaptchaError("");
    setErrors({});
	
	
	
	//upload photo Reset the state and clear inputs
      setPhotos([null, null, null]);
      fileInputsRef.current.forEach((input) => (input.value = ""));
      setValidationMessage("");

	//upload photo ends here
	
	
	//reset payment
	
	setIsPaid(false); // Reset payment status
      setAmount(4000); // Reset amount to original price
      setDiscount(0); // Reset discount
      setPromoCode(""); // Clear promo code input
	
	 }
  
};

  
  

  
  
  
  

  return (
 <div
  className="container"
  style={{
    padding: '1rem', // Use rem for consistent spacing
    fontFamily: 'Arial, sans-serif',
    backgroundColor: '#f7f7f7',
    maxWidth: '100%', // Use percentage for dynamic width
    margin: '0 auto', // Center the content
  }}
>

    <form
      ref={formRef}
	  onSubmit={handleSubmit}
	  
      style={{
        backgroundColor: '#ffffff',
        padding: '20px',
        borderRadius: '8px',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
      }}
    >
      

      {/* Form Fields and To-Do List Section */}
      <div style={{ marginBottom: '0px' }}>
      {/*  <h2 style={{ fontSize: '20px', color: '#007bff', marginBottom: '10px' }}>Form Fields</h2>*/}
        <FormSection formData={formData} handleChange={handleChange} errors={errors} />
		<Semester value={formData1} onChange={handleChange1}  />
      </div>
      <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "0px",
        maxWidth: "100%",
      }}
    >
        
        <TodoList todos={todos} setTodos={handleTodoInputChange} />
        {todoError && <p style={{ color: 'red' }}>{todoError}</p>}
		
        <button
          type="button"
          onClick={handleDeleteAllTodos}
          style={{
            marginTop: '10px',
            padding: '10px 20px',
            backgroundColor: '#ff4d4d',			
            color: '#fff',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
			
          }}
			  
        >
          Delete All Subjects
        </button>
      </div>

     



	 {/* Sticker Selection Section */}
	  <div style={{ display: 'flex', flexDirection: 'column', gap: '20px', padding: '20px', justifyContent: 'center' }}>
     
      <div style={{ padding: '20px', border: '2px solid #007bff', borderRadius: '10px', backgroundColor: '#f8f9fa', maxWidth: '100%' }}>
        <h3 style={{ textAlign: 'center', color: '#007bff' }}>Select Stickers</h3>
      <ImageSelector
          images={filteredImages}
          selectedImages={selectedImages}
          highlightedImages={highlightedImages}
          setSelectedImages={setSelectedImages}
          setHighlightedImages={setHighlightedImages}
          setShowValidationMessage={setShowValidationMessage}
          setFilter={setFilter}
          showValidationMessage={showValidationMessage}
          resetDefaults={resetDefaults} // Pass resetDefaults prop
        />
		</div>
		</div>
		
		
		
		{/* upload Photo */}
		
		
		<div className="container">
  <div className="grid-container">
    {labels.map((label, index) => (
      <ImagePhoto
        key={index}
        index={index}
        label={label}
        setImage={(photo) => handlePhotoUpload(photo, index)}
        images={photos}
        setImages={setPhotos}
        fileInputsRef={fileInputsRef}
      />
    ))}
    {validationMessage && (
      <p className="validation-message">{validationMessage}</p>
    )}
  </div>
</div>


		
		
		
		 {/* ends upload photo */}
		
		
		

      {/* Captcha Section */}
      <div style={{
        display: "flex",
        flexDirection: "column",
        gap: "0px",
        maxWidth: "100%",
      }}>
        <Captcha
          captcha={captcha}
          refreshCaptcha={refreshCaptcha}
          userCaptcha={userCaptcha}
          setUserCaptcha={handleCaptchaChange}
        />
        {captchaError && <p style={{ color: 'red' }}>{captchaError}</p>}
      </div>
	  
	  
	  
	 <div style={{  
  color: "Blue", 
  fontSize: "0.9rem",  
  textAlign: "center",
  fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif"
  }}>
  Apply PITICS Promo to get Rs 5/- off
  </div>

      
      {!isPaid && (
        <>
          <div style={{ marginBottom: "15px" }}>
            <input
              type="text"
              placeholder="Enter Promo Code"
              value={promoCode}
              onChange={(e) => setPromoCode(e.target.value)}
              style={{
                padding: "8px",
                fontSize: "16px",
                border: "1px solid #ccc",
                borderRadius: "5px",
                marginRight: "10px",
                width: "200px"
              }}
            />
            <button
              onClick={applyPromoCode}
              style={{
                padding: "8px 15px",
                fontSize: "16px",
                backgroundColor: "#007BFF",
                color: "white",
                border: "none",
                borderRadius: "5px",
                cursor: "pointer"
              }}>
              Apply
            </button>
          </div>

          {errorPayment && <p style={{ color: "red", fontSize: "16px" }}>{errorPayment}</p>}
          
          {discount > 0 && (
            <div style={{
              backgroundColor: "#e6f7e6",
              color: "#28a745",
              padding: "10px",
              display: "inline-block",
              borderRadius: "5px",
              fontSize: "16px",
              fontWeight: "bold"
            }}>
              Discount Applied: ₹{discount / 100}  
              <button 
                onClick={removeDiscount} 
                style={{
                  marginLeft: "10px",
                  backgroundColor: "transparent",
                  color: "#ff4d4d",
                  fontSize: "16px",
                  border: "none",
                  cursor: "pointer",
                  fontWeight: "bold"
                }}>
                ❌
              </button>
            </div>
          )}

          <div style={{ marginTop: "20px" }}>
            <PaymentButton setIsPaid={setIsPaid} amount={amount} 
			validateForm={validateForm}
			promoCode={promoCode} // ✅ Add this line
			
			/>
          </div>
        </>
      )}
      
      {isPaid && (
  <div style={{ marginTop: "10px" }}>
    <p style={{ color: "#28a745", fontWeight: "bold" }}>
      Payment successful! Downloading Stickers...
    </p>
  </div>
)}
	   
    </form>

    {/* QR Code Section */}
    {todos.map((todo, index) => (
      <HiddenQRCode key={`qr-${index}`} id={`qr-${index}`} 
	  value={
		  `I'm ${formData.name1}\n
		  Studying ${formData.study1}\n
		  My ${formData.selection5} is ${formData.comm}`
		  } />
    ))}
  </div>
);

};

export default Topo;